import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["name", "render", "inputProps", "itemProps"];
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Button, Popover } from 'antd';
import { EMPTY_ARRAY, EMPTY_OBJECT, NO_OP } from '../../../../../constants/Constants';
export const CommonForm = Form.create({
  name: 'resize-form'
})(_ref => {
  let {
    form,
    formProps,
    formItems,
    onSubmit
  } = _ref;
  const hasErrors = useCallback(fieldsError => Object.keys(fieldsError).some(field => fieldsError[field]), []);
  const handleSubmit = useCallback(e => {
    e.preventDefault();
    form.validateFields((err, values) => {
      if (!err) {
        onSubmit(values);
      }
    });
  }, []);
  useEffect(() => {
    form.validateFields();
  }, []);
  return /*#__PURE__*/React.createElement(Form, _extends({}, formProps, {
    className: "tap-editor-form",
    onSubmit: handleSubmit
  }), formItems.map(_ref2 => {
    let {
        name,
        render,
        inputProps,
        itemProps
      } = _ref2,
      fieldDecorators = _objectWithoutProperties(_ref2, _excluded);
    const itemError = form.isFieldTouched(name) && form.getFieldError(name);
    return /*#__PURE__*/React.createElement(Form.Item, _extends({
      validateStatus: itemError ? 'error' : '',
      help: itemError || ''
    }, itemProps), form.getFieldDecorator(name, fieldDecorators)(render ? render() : /*#__PURE__*/React.createElement(Input, inputProps)));
  }), /*#__PURE__*/React.createElement(Form.Item, null, /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    htmlType: "submit",
    disabled: hasErrors(form.getFieldsError())
  }, "Submit")));
});
CommonForm.propTypes = {
  form: PropTypes.object.isRequired,
  formItems: PropTypes.array,
  formProps: PropTypes.object,
  onSubmit: PropTypes.func
};
CommonForm.defaultProps = {
  formItems: EMPTY_ARRAY,
  formProps: EMPTY_OBJECT,
  onSubmit: NO_OP
};
const FormPopover = _ref3 => {
  let {
    children,
    formItems,
    formProps,
    popoverProps,
    onSubmit
  } = _ref3;
  const [showPopover, setShowPopover] = useState(false);
  const onSubmitForm = useCallback(data => {
    onSubmit(data);
    setShowPopover(false);
  }, []);
  return /*#__PURE__*/React.createElement(Popover, _extends({
    content: /*#__PURE__*/React.createElement(CommonForm, {
      formItems: formItems,
      formProps: formProps,
      onSubmit: onSubmitForm
    }),
    overlayClassName: "tap-editor-formpopover",
    placement: "bottom",
    trigger: "click"
  }, popoverProps, {
    visible: showPopover,
    onVisibleChange: visible => setShowPopover(visible)
  }), children);
};
FormPopover.propTypes = {
  children: PropTypes.any,
  formItems: PropTypes.array,
  formProps: PropTypes.object,
  popoverProps: PropTypes.object,
  onSubmit: PropTypes.func
};
FormPopover.defaultProps = {
  children: null,
  formItems: EMPTY_ARRAY,
  formProps: EMPTY_OBJECT,
  popoverProps: EMPTY_OBJECT,
  onSubmit: NO_OP
};
export default FormPopover;